import { BreadcrumbStateInfo, SiteUrlsContext } from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';
import { Route } from 'react-router';
import { defaultMemoize } from 'reselect';
import { createCatalogTablesBreadcrumb } from './BreadcrumbFactories';
import { BreadcrumbsUpdater } from './BreadcrumbsUpdater';

function createTablesBreadcrumbsList(
  urls: SiteUrls,
  urlSuffix: string,
): ReadonlyArray<BreadcrumbStateInfo> {
  return [
    createCatalogTablesBreadcrumb(urls, urlSuffix)
  ];
}

export type TablesBreadcrumbsUpdaterProps = {
};

export class TablesBreadcrumbsUpdater extends React.Component<TablesBreadcrumbsUpdaterProps> {

  // tslint:disable-next-line: typedef
  private readonly memoizedCreateTablesBreadcrumbsList = defaultMemoize(createTablesBreadcrumbsList);

  public render() {
    return (
      <SiteUrlsContext.Consumer>
        {urls =>
          <Route>
            {({ location }) => {
              const breadcrumbs = this.memoizedCreateTablesBreadcrumbsList(urls, location.search);
              return (
                <BreadcrumbsUpdater breadcrumbs={breadcrumbs} />
              );
            }}
          </Route>
        }
      </SiteUrlsContext.Consumer>
    );
  }

}
